import "./views.scss";

import { faLock } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect } from "react";

import TextInput from "../components/forms/formFields/TextInput";
import { useFormFlowContext } from "../components/forms/FormFlowContext";
import { getFieldAttributes } from "../helpers/formDataHelpers";
import { triggerCommunityRegistrationView } from "../helpers/observability/analytics";

const CreatePassword = ({ formMethods, onClickCreateAccount }) => {
  const { userData } = useFormFlowContext();
  const { getFormState } = formMethods;
  const formState = getFormState();
  const fields = formState?.fields || {};

  useEffect(() => {
    triggerCommunityRegistrationView({
      event_action: "set_password",
      event_label: "set_password"
    });
  }, []);

  const usernameFieldAttributes = getFieldAttributes(
    {
      label: "Username",
      name: "hubUsername",
      required: true,
      prepopulate: "email",
      validationType: "email",
      editable: false
    },
    userData,
    fields
  );

  const passwordFieldAttributes = getFieldAttributes(
    {
      label: "Create a password",
      name: "password",
      fieldType: "password",
      fieldValue: fields.password?.value,
      required: true,
      validationType: "password"
    },
    userData,
    fields
  );

  return (
    <div className="views">
      <div className="header">
        <h1 className="serif">
          <strong>Create a Password</strong>
        </h1>
      </div>
      <p className="base">Enter a secure password for your Community Hub account.</p>
      <TextInput formMethods={formMethods} fieldAttributes={usernameFieldAttributes} />
      <TextInput formMethods={formMethods} fieldAttributes={passwordFieldAttributes} />
      <footer className="footer">
        <button
          className="btn btn-primary"
          disabled={!fields.password?.isValid}
          onClick={onClickCreateAccount}>
          <FontAwesomeIcon icon={faLock} /> CREATE MY ACCOUNT
        </button>
      </footer>
    </div>
  );
};

export default CreatePassword;
